import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import helperMarkdownToComponent from 'helpers/Data';
import { onEnterKeyPress } from 'helpers/Account';
import OverlayFooter from 'components/OverlayFooter';
import Header from '../Header';

import Style from './SocialFacebookPasswordLink.module.scss';

const SocialFacebookPasswordLink = ({
  facebookEmail,
  facebookPasswordLinkGenericError,
  facebookPasswordLinkPassword,
  facebookPasswordLinkPasswordError,
  facebookPasswordLinkShowPassword,
  handleClick,
  headerProps,
  language,
  onFieldChange,
}) => {
  const {
    profileError_passwordLength: passwordLengthError,
    profile_facebookLoginTitle: facebookLoginTitle,
    profile_facebookLoginHeader: facebookLoginHeader,
    profile_facebookLoginCopy: facebookLoginCopy,
    profileCreate_optinCombinedText: optinText,
    profileCreate_createButton: createButtonText,
  } = language || {};

  let socialFbLinkPasswordInput = React.createRef();
  let errorText = '';
  let passwordErrorText;

  const passwordType = facebookPasswordLinkShowPassword ? 'text' : 'password';

  if (facebookPasswordLinkPasswordError) {
    passwordErrorText = passwordLengthError;
  }

  if (!passwordErrorText) {
    errorText = facebookPasswordLinkGenericError;
  }

  return (
    <main className={Style.SocialFacebookPasswordLink}>
      <Header {...headerProps} />
      <div className={Style.SocialFacebookPasswordLinkWrap}>
        <div className={Style.signupFormContainer}>
          <div className={Style.headerTextDesktop}>{facebookLoginTitle}</div>
          <div className={Style.facebookPasswordLinkHeader}>{facebookLoginHeader}</div>
          <div className={Style.facebookPasswordLinkCopy}>{facebookLoginCopy}</div>
          <div className={Style.error}>{errorText}</div>
          <div className={Style.signupPasswordContainer}>
            <input
              className={Style.inputField}
              type="text"
              name="facebookPasswordLoginLinkEmail"
              placeholder="Email"
              value={facebookEmail}
              autoCapitalize="none"
              disabled
            />
          </div>
          <div className={Style.signupPasswordContainer}>
            <input
              className={Style.inputField}
              type={passwordType}
              name="facebookPasswordLinkPassword"
              placeholder="Password"
              value={facebookPasswordLinkPassword}
              onChange={onFieldChange}
              ref={input => {
                socialFbLinkPasswordInput = input;
              }}
              autoCapitalize="none"
              autoComplete="off"
              autoCorrect="off"
              spellCheck={false}
              onKeyPress={e => {
                onEnterKeyPress(e, handleClick);
              }}
            />
            <label className={Style.passwordLabel}>
              <input
                name="facebookPasswordLinkShowPassword"
                type="checkbox"
                value={facebookPasswordLinkShowPassword}
                onChange={e => {
                  onFieldChange(e);
                  socialFbLinkPasswordInput.focus();
                }}
              />
              <span />
            </label>
          </div>
          <div className={Style.error}>{passwordErrorText}</div>
          <div
            className={classNames(Style.termsText, Style.signupTerms, Style.signupTermsContainer)}
          >
            {helperMarkdownToComponent(optinText, null, {
              /* eslint-disable */
              Paragraph: props => {
                const { children } = props;
                if (!children) return null;
                return <p className={Style.termsText}>{children}</p>;
              },
              Link: props => (
                <a
                  href={props.href}
                  className={Style.legalDisclaimerLink}
                  target="noopener noreferrer"
                >
                  {props.children}
                </a>
              ),
            })}
          </div>
          <button className={Style.btnPrimary} onClick={handleClick}>
            {createButtonText}
          </button>
        </div>
      </div>
      <OverlayFooter language={language} />
    </main>
  );
};

SocialFacebookPasswordLink.defaultProps = {
  facebookPasswordLinkGenericError: null,
  facebookPasswordLinkPassword: null,
  facebookPasswordLinkPasswordError: null,
  facebookPasswordLinkShowPassword: null,
  language: {},
};

SocialFacebookPasswordLink.propTypes = {
  facebookEmail: PropTypes.string.isRequired,
  facebookPasswordLinkGenericError: PropTypes.string,
  facebookPasswordLinkPassword: PropTypes.string,
  facebookPasswordLinkPasswordError: PropTypes.string,
  facebookPasswordLinkShowPassword: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  headerProps: PropTypes.shape({}).isRequired,
  language: PropTypes.shape({
    profileError_passwordLength: PropTypes.string,
    profile_facebookLoginTitle: PropTypes.string,
    profile_facebookLoginHeader: PropTypes.string,
    profile_facebookLoginCopy: PropTypes.string,
    profileCreate_optinCombinedText: PropTypes.string,
    profileCreate_createButton: PropTypes.string,
  }),
  onFieldChange: PropTypes.func.isRequired,
};

export default SocialFacebookPasswordLink;
